import {observable, action, runInAction} from 'mobx'
import { get } from '../../../utils/ajax'
import moment from 'moment'
import {handleSeerchAndPage,  ValueObjToObj} from "../../../utils/Utils";

class UserLoginRecordStore {
    @observable loading  //页面加载loading
    @observable list    //列表数据
    @observable pagination   //分页
    @observable searchField   //搜索表单绑值


    constructor() {
        this.loading = false
        this.list = []
        this.pagination = {
            total:1,
            current: 0,
            showQuickJumper: true
        }
        this.searchField={
            userName:'',
            userRoleName:'',
            district:'',
            serviceCodeOrServiceName:'',
            startTime:'',
            endTime:''
        }
    }

    /**
     * 根据条件或无条件分页查询主页信息
     */
    @action
    onChangedFields=(changedFields)=>{
        const change=ValueObjToObj(changedFields)
        this.searchField={...this.searchField,...change}
    }

    /**
     * 根据条件或无条件分页查询主页信息
     */
    @action
    initPage = async (temPage) => {
        this.loading=true
        let searchField = {
            ...this.searchField,
            startTime: this.searchField.startTime ? moment(this.searchField.startTime).format("YYYY-MM-DD") : '',
            endTime: this.searchField.endTime ? moment(this.searchField.endTime).format("YYYY-MM-DD") : ''
        };
        let search=handleSeerchAndPage(temPage,this.pagination ,searchField)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/serviceStation/stationUser/station/obtainUserLoginLogsList`,search)
        runInAction(() => {
            this.list = res.content ? res.content : []
            this.pagination = {
                total: res.totalElements  || 1,
                current: res.number + 1 || 0,
                showQuickJumper: true
            }
            this.loading=false
        })
    }

    /**清空搜索**/
    @action
    searchReset = () => {
        this.searchField = {
            userName:'',
            userRoleName:'',
            district:'',
            serviceCodeOrServiceName:'',
            startTime:'',
            endTime:''
        }
        this.initPage()
    }

}

export default new UserLoginRecordStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/UserLoginRecord/store.js